// The export names can be nouns or verbs

export const HOME = "/";
export const SIGNIN = "/login";
export const SIGNIN_TWO_FACTOR_CONFIRMATION = "/login/verify";
export const SIGNUP = "/register";
export const REQUEST_PASSWORD_RESET = "/password/forgot";
export const RESET_PASSWORD = "/password/reset";
export const RESET_PASSWORD_TWO_FACTOR_AUTHENTICATION = "/password/reset/verify";
export const SHOP = "/shop";
export const BRAND = "/shop/brands/:brandName";
export const CATEGORY = "/shop/categories/:categoryName";
export const CART = "/cart";
export const CHECKOUT = "/checkout";
export const PRODUCT = "/products/:productId";
export const PAYMENT_STATUS = "/payments/status";
export const PAY_FOR_ORDER = "/orders/:orderReferenceNumber/pay";
export const WISHLIST = "/wishlist";
export const VERIFY_EMAIL = "/email/verify";
export const PRODUCT_COMPARE = "/products/:productId/compare";
export const ORDER_TRACKING = "/orders/:orderReferenceNumber/track";
export const PRIVACY_POLICY = "/privacy-policy";
export const ABOUT_US = "/about-us";
export const CONTACT_US = "/contact-us";
export const SEARCH = "/shop/search";
export const ORDER_LISTING = "/orders";
export const ORDER_DETAILS = "/orders/:orderReferenceNumber";

